import { IconBell } from '@tabler/icons-react';
import type { PushCardItem } from '@/hooks/usePushCards';

export function PushCard({ item }: { item: PushCardItem }) {
  return (
    <div className={`rides-pushcard ${item.kind ?? ''}`} role="status">
      <span style={{ color: 'var(--rides-primary)', display: 'inline-flex', flex: '0 0 auto' }} aria-hidden="true">
        <IconBell size={20} />
      </span>
      <span style={{ minWidth: 0 }}>
        <b style={{ display: 'block', fontSize: 14 }}>{item.title}</b>
        <span style={{ display: 'block', color: 'var(--rides-muted)', fontSize: 13 }}>{item.body}</span>
      </span>
    </div>
  );
}

/** Newest first; polite live region so screen readers hear ride updates. */
export function PushCardStack({ items }: { items: PushCardItem[] }) {
  if (!items.length) return null;
  return (
    <div className="rides-stack" aria-live="polite" aria-relevant="additions">
      {items.map((it) => <PushCard key={it.id} item={it} />)}
    </div>
  );
}
